/**
 * Web Token Storage
 * Uses sessionStorage for sensitive tokens and localStorage for refresh tokens
 */
import { STORAGE_KEYS } from "./tokenStorage";
/**
 * Web implementation of TokenStorage
 * - Access token: sessionStorage (cleared on tab close)
 * - Refresh token: localStorage (persists across sessions)
 * - ID token: sessionStorage
 */
class WebTokenStorage {
    async setTokens(tokens) {
        try {
            // Store sensitive tokens in sessionStorage
            sessionStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, tokens.accessToken);
            sessionStorage.setItem(STORAGE_KEYS.ID_TOKEN, tokens.idToken);
            sessionStorage.setItem(STORAGE_KEYS.EXPIRES_AT, String(tokens.expiresAt));
            sessionStorage.setItem(STORAGE_KEYS.TOKEN_TYPE, tokens.tokenType);
            // Store refresh token in localStorage for persistence
            if (tokens.refreshToken) {
                localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, tokens.refreshToken);
            }
        }
        catch (error) {
            console.error("Failed to store tokens:", error);
            throw error;
        }
    }
    async getTokens() {
        try {
            const accessToken = sessionStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
            const idToken = sessionStorage.getItem(STORAGE_KEYS.ID_TOKEN);
            const expiresAtStr = sessionStorage.getItem(STORAGE_KEYS.EXPIRES_AT);
            const tokenType = sessionStorage.getItem(STORAGE_KEYS.TOKEN_TYPE);
            const refreshToken = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
            if (!accessToken || !idToken || !expiresAtStr || !tokenType) {
                return null;
            }
            const expiresAt = parseInt(expiresAtStr, 10);
            return {
                accessToken,
                idToken,
                refreshToken: refreshToken ?? undefined,
                expiresAt,
                tokenType,
            };
        }
        catch (error) {
            console.error("Failed to retrieve tokens:", error);
            return null;
        }
    }
    async clearTokens() {
        try {
            sessionStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
            sessionStorage.removeItem(STORAGE_KEYS.ID_TOKEN);
            sessionStorage.removeItem(STORAGE_KEYS.EXPIRES_AT);
            sessionStorage.removeItem(STORAGE_KEYS.TOKEN_TYPE);
            localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
        }
        catch (error) {
            console.error("Failed to clear tokens:", error);
            throw error;
        }
    }
    async hasTokens() {
        const accessToken = sessionStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
        return accessToken !== null;
    }
}
export const tokenStorage = new WebTokenStorage();
//# sourceMappingURL=tokenStorage.web.js.map